import {
  Button,
  DatePicker,
  Divider,
  Input,
  message,
  Select,
  Spin,
} from "antd";
import { FormLabel } from "../form-label";
import styles from "./styles.module.scss";
import { ReactComponent as DropdownArrow } from "icons/dropdownArrow.svg";

import dayjs from "dayjs";

import {
  AcademyIcon,
  CountryIcon,
  EmailIcon,
  MobileIcon,
  NameIcon,
  RoleIcon,
  RoleStrikerIcon,
  StudioPlatformIcon,
  TrialIcon,
  WebPlatformIcon,
  FormNameIcon,
  FormGenderIcon,
  FormDateIcon,
  FormEmailAddressIcon,
  FormHeightIcon,
  FormWeightIcon,
  FormStreetIcon,
  FormHouseIcon,
  FormZipCodeIcon,
  FormCityIcon,
  FormCountryIcon,
  DeactivateIcon,
} from "icons";
import { CustomSelect } from "components/custom-select";
import { useEffect, useMemo, useState } from "react";
import { FormItem } from "pages/statistics/filterV1/filterModal";
import { CustomDatePicker } from "components";
import moment from "moment";
import { GenderID } from "utils/constants";
import { UseLazyApiCallOldDashboard } from "hooks/use-lazy-api-call-old-dashboard";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";
import { useRecoilState } from "recoil";
import { persistedUserOrStrikerId } from "store/atom";
import { UseLazyApiCall } from "hooks";

export const PersonalDetailsForm = ({
  userDetails,
  address,
  getUsers,
  page,
  size,
  search,
}) => {
  const { Option } = Select;
  const {
    firstName,
    lastName,
    genderId,
    dateOfBirth,
    email,
    height,
    weight,
    heightUnit,
    weightUnit,
  } = userDetails || {};

  const {
    addressLine1,
    postCode,
    addressLine2,
    country,
    city,
    cityId,
    countryId,
  } = address || {};
  const userID = userDetails?.id;

  const [
    passwordResetter,
    {
      data: passwordResetterData,
      isLoading: passwordResetterLoading,
      passwordResetterError,
    },
  ] = UseLazyApiCall({
    url: "/user/password/resetter",
    method: "POST",
    paramsData: {
      email: userDetails?.email,
    },
  });

  const {
    data: countriesList,
    isLoading: countriesListLoading,
    refetch: countriesListRefetch,
  } = UseApiCallForOldDashboardData({
    url: "show_countries",
    method: "POST",
    skip: !userID,
    body: {
      userID: userID,
    },
  });

  let finalCountriesList = [];

  if (countriesList?.countries) {
    finalCountriesList = countriesList?.countries?.filter(
      (country) => country?.name
    );
  }

  const initialData = {
    userId: userDetails?.id,
    firstName,
    lastName,
    gender: genderId,
    dateOfBirth,
    email,
    height,
    weight,
    heightUnit,
    weightUnit,
    country,
    city,
    street: addressLine1,
    houseNumber: addressLine2,
    zipCode: postCode,
    countryId,
    cityId,
  };

  // const initialData = {
  //   ...userDetails,
  //   ...address,
  // };

  const [userFormData, setUserFormData] = useState(initialData);

  const [sendLinkOnEmail, { isLoading: sendLinkOnEmailloading }] =
    UseLazyApiCallOldDashboard({
      method: "POST",
    });

  const [getCitiesList, { data: citiesList, isLoading: citiesListLoading }] =
    UseLazyApiCallOldDashboard({
      method: "POST",
      url: "get_city",
    });

  async function resetPassword() {
    try {
      const res = await passwordResetter();
      if (res.message === "Success") {
        message.success(
          `Reset password link sent successfully to ${userDetails?.email}.`
        );
      }
    } catch (error) {
      message.error("Something went wrong.");
    }
  }

  async function sendResetLinkOnEmail({ apiPath }) {
    try {
      const response = await sendLinkOnEmail({
        url: `${apiPath}`,
        params: {
          email: userDetails?.email,
          name: `${userDetails?.firstName} ${userDetails?.lastName}`,
        },
      });
      if (response.status === "Success") {
        message.success(
          `Reset Link sent successfully on ${userDetails?.email}`
        );
      }
    } catch (error) {
      console.log({ error });
    }
  }

  const [
    updateUser,
    { data: updateUserData, isLoading: updateUserLoading, error },
  ] = UseLazyApiCallOldDashboard({
    url: "edit_user_detail",
    method: "POST",
  });

  useEffect(() => {
    setUserFormData(initialData);
  }, [userDetails]);

  useEffect(() => {
    if (countryId) {
      getInitialCities(countryId);
    }
  }, [countryId]);

  async function getInitialCities(countryCode) {
    try {
      await getCitiesList({
        params: { countryId: countryCode },
      });
    } catch (error) {
      console.log({ error });
    }
  }

  const platformItems = [
    {
      title: "Mobile Application",
      key: "mobileApplication",
      isActive: true,
      Icon: MobileIcon,
      borderColor: "#006AB3",
    },
    {
      title: "Web Application",
      key: "webApplication",
      isActive: false,
      Icon: WebPlatformIcon,
      borderColor: "#F4BD00",
    },
    {
      title: "Studio Application",
      key: "studioApplication",
      isActive: false,
      Icon: StudioPlatformIcon,
      borderColor: "#78ba2c",
    },
  ];

  const [platformData, setPlatformData] = useState(platformItems);

  async function handleSubmitForm(e) {
    e.preventDefault();

    try {
      const response = await updateUser({
        params: {
          ...userFormData,
          city: 5,
          country: 92,
        },
      });
      if (response.success) {
        message.success(response.message);
        getUsers({
          page,
          size,
          search,
        });
      }
    } catch (error) {
      console.log({ error });
    }
  }
  const planOptions = ["Pakistan", "Bangladesh", "China"];
  const genderOptions = ["Male", "Female", "Other"];

  function handleChangePlan(e) {}
  function handleChangeGender(e) {}

  function handleChangePlatform(clickedItem) {
    const newdata = platformData.map((itemObj) =>
      clickedItem.title === itemObj.title
        ? { ...itemObj, isActive: true }
        : { ...itemObj, isActive: false }
    );

    setPlatformData(newdata);
  }

  const selectedOption = useMemo(
    () => platformData?.find((item) => item?.isActive),
    [platformData]
  );

  function handleChange(e) {
    const { name, value } = e.target;

    setUserFormData((prev) => {
      return { ...prev, [name]: value };
    });
  }

  function handleChangeDropdown(value, { name }) {
    setUserFormData((prev) => {
      return { ...prev, [name]: value };
    });
  }
  const onChangeDate = (date, dateString) => {
    setUserFormData({ ...userFormData, dateOfBirth: dateString });
  };

  function resetForm() {
    setUserFormData(initialData);
  }

  async function handleChangeCountry(id, { label, value, key }) {
    try {
      const res = await getCitiesList({
        params: {
          countryId: parseInt(key),
        },
      });
      setUserFormData({
        ...userFormData,
        country: label,
        countryId: parseInt(key),
        city: res?.cities[0].name,
        cityId: res?.cities[0].id,
      });
    } catch (error) {
      console.log({ error });
    }
  }

  function handleChangeCity(id, { label, value, key }) {
    setUserFormData({
      ...userFormData,
      city: label,
      cityId: parseInt(key),
    });
  }

  const inputFieldHeight = "4.4dvh";
  return (
    <div className={styles.addUserContainer}>
      <Spin spinning={!!updateUserLoading || !!citiesListLoading}>
        <form onSubmit={handleSubmitForm}>
          <div className={styles.name}>
            <div>
              <FormLabel label="First Name" Icon={FormNameIcon} />
              <Input
                style={{ height: inputFieldHeight }}
                type="text"
                placeholder="Enter First Name"
                name="firstName"
                value={userFormData.firstName}
                onChange={handleChange}
              />
            </div>
            <div>
              <FormLabel label="Last Name" Icon={FormNameIcon} />
              <Input
                style={{ height: inputFieldHeight }}
                type="text"
                placeholder="Enter Last Name"
                name="lastName"
                value={userFormData.lastName}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className={styles.name}>
            <div>
              <FormLabel label="Gender" Icon={FormGenderIcon} />

              <CustomSelect
                value={GenderID[userFormData.gender]}
                defaultValue={userFormData.gender}
                optionsArray={genderOptions}
                style={{
                  select: {
                    width: "100%",
                    height: inputFieldHeight,
                  },
                }}
                variant="user-detail"
                onChange={handleChangeGender}
              />
            </div>
            <div>
              <FormLabel label="Date of Birth" Icon={FormDateIcon} />
              {/* <Input
              style={{ height: inputFieldHeight }}
              type="date"
              placeholder="Select Date"
              value={userFormData.dateOfBirth}
            /> */}
              <DatePicker
                name="dateOfBirth"
                value={
                  userFormData?.dateOfBirth && dayjs(userFormData?.dateOfBirth)
                }
                onChange={onChangeDate}
                style={{ height: inputFieldHeight, width: "100%" }}
              />
            </div>
          </div>
          <div className={styles.name}>
            <div>
              <FormLabel label="Email Address" Icon={FormEmailAddressIcon} />
              <Input
                style={{ height: inputFieldHeight }}
                type="email"
                name="email"
                value={userFormData.email}
                disabled
              />
              <div
                style={{
                  justifySelf: "end",
                  textDecoration: "underline",
                  color: "#006AB3",
                  cursor: "pointer",
                }}
                onClick={() =>
                  sendResetLinkOnEmail({ apiPath: "send_email_change_email" })
                }
              >
                Reset Email Address
              </div>
            </div>
            <div>
              <FormLabel label="Password" Icon={FormNameIcon} />
              <Input
                style={{ height: inputFieldHeight }}
                type="password"
                name="password"
                value={"********"}
                disabled
              />
              <Spin spinning={passwordResetterLoading}>
                <div
                  style={{
                    justifySelf: "end",
                    textDecoration: "underline",
                    color: "#006AB3",
                    cursor: "pointer",
                  }}
                  onClick={resetPassword}
                >
                  Reset Password
                </div>
              </Spin>
            </div>
          </div>

          <div className={styles.heading}>Body Metrics</div>
          <div className={styles.name}>
            <div style={{ display: "flex", gap: "10px" }}>
              <div style={{ flex: "1" }}>
                <FormLabel label="Height" Icon={FormHeightIcon} />
                <Input
                  style={{ height: inputFieldHeight }}
                  type="text"
                  placeholder="Enter Height"
                  name="height"
                  value={userFormData.height}
                  onChange={handleChange}
                />
              </div>
              <Select
                value={userFormData.heightUnit}
                name="heightUnit"
                style={{
                  height: inputFieldHeight,
                  width: "70px",
                  alignSelf: "end",
                }}
                onChange={(value) =>
                  handleChangeDropdown(value, { name: "heightUnit" })
                }
                options={[
                  { value: "cm", label: "cm" },
                  { value: "inch", label: "inch" },
                ]}
                suffixIcon={<DropdownArrow />}
              />
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <div style={{ flex: "1" }}>
                <FormLabel label="Weight" Icon={FormWeightIcon} />
                <Input
                  style={{ height: inputFieldHeight }}
                  type="text"
                  placeholder="Enter weight"
                  name="weight"
                  value={userFormData.weight}
                  onChange={handleChange}
                />
              </div>
              <Select
                defaultValue="kg"
                value={userFormData.weightUnit}
                style={{
                  height: inputFieldHeight,
                  alignSelf: "end",
                  width: "70px",
                }}
                onChange={(value) =>
                  handleChangeDropdown(value, { name: "weightUnit" })
                }
                name="weightUnit"
                options={[
                  { value: "kg", label: "kg" },
                  { value: "lb", label: "lb" },
                ]}
                suffixIcon={<DropdownArrow />}
              />
            </div>
          </div>
          <div className={styles.heading}>Address Details</div>

          <div className={styles.name}>
            <div>
              <FormLabel label="Street" Icon={FormStreetIcon} />
              <Input
                style={{ height: inputFieldHeight }}
                type="text"
                placeholder="Enter street"
                onChange={handleChange}
                name="street"
                value={userFormData.street}
              />
            </div>
            <div>
              <FormLabel label="House Number" Icon={FormHouseIcon} />
              <Input
                style={{ height: inputFieldHeight }}
                type="text"
                placeholder="Enter house no."
                onChange={handleChange}
                name="houseNumber"
                value={userFormData.houseNumber}
              />
            </div>
          </div>
          <div className={styles.name}>
            <div>
              <FormLabel label="Zip Code" Icon={FormZipCodeIcon} />
              <Input
                style={{ height: inputFieldHeight }}
                type="text"
                placeholder="Enter zip code"
                onChange={handleChange}
                name="zipCode"
                value={userFormData.zipCode}
              />
            </div>
            <div>
              <FormLabel label="Country" Icon={FormCountryIcon} />

              <Select
                // showSearch
                // placeholder="Select a country"
                // optionFilterProp="label"
                // value={userFormData?.country}
                // suffixIcon={<DropdownArrow />}
                // onChange={handleChangeCountry}
                style={{ width: "100%", height: inputFieldHeight }}
              >
                {finalCountriesList?.map((country) => (
                  <Option
                    key={country.id}
                    value={country.id}
                    label={country.name}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={country.img}
                        alt={country.name}
                        style={{ width: 20, marginRight: 8 }}
                      />
                      {country.name}
                    </div>
                  </Option>
                ))}
              </Select>
            </div>
          </div>

          <div>
            <FormLabel label="City" Icon={FormCityIcon} />

            <Select
              showSearch
              style={{ width: "50%", height: inputFieldHeight }}
              placeholder="Select a city"
              optionFilterProp="label"
              value={userFormData?.city}
              suffixIcon={<DropdownArrow />}
              onChange={handleChangeCity}
            >
              {citiesList?.cities?.map((city) => (
                <Option key={city.id} value={city.id} label={city.name}>
                  {city.name}
                </Option>
              ))}
            </Select>
          </div>
          <div className={styles.buttons}>
            <div></div>
            <div style={{ display: "flex", gap: "10px" }}>
              <Button
                style={{ backgroundColor: "#6F7174", color: "white" }}
                size="large"
                onClick={resetForm}
              >
                Cancel
              </Button>
              <Button
                style={{ backgroundColor: "#006AB3", color: "white" }}
                size="large"
                // disabled
                type="primary"
                htmlType="submit"
              >
                Save
              </Button>
            </div>
          </div>
        </form>
      </Spin>
    </div>
  );
};
